import { GeneralSuccessResponse } from '@data-types/generic';
import { showToast } from '@slices/apiSlice';
import { baseApi } from '@store/baseQuery';

import { ContactSupportPayload, Faqs } from '../types';

export const faqs = baseApi.injectEndpoints({
    endpoints: builder => ({
        getAllFaqs: builder.query<Faqs, {}>({
            query: () => ({
                url: '/faqs?offset=0&limit=-1&orderBy=createdAt&orderDirection=DESC',
                method: 'GET',
            }),
            async onQueryStarted(_arg, { dispatch, queryFulfilled }) {
                try {
                    await queryFulfilled;
                } catch (error) {
                    dispatch(showToast({ variant: 'error', description: error?.error }));
                }
            },
        }),
        getMentorFaqs: builder.query<Faqs, { search?: string }>({
            query: args => ({
                url: '/mentor/faqs?offset=0&limit=100&orderBy=createdAt&orderDirection=DESC',
                method: 'GET',
                params: {
                    search: args.search,
                },
            }),
            async onQueryStarted(_arg, { dispatch, queryFulfilled }) {
                try {
                    await queryFulfilled;
                } catch (error) {
                    dispatch(showToast({ variant: 'error', description: error?.error }));
                }
            },
        }),
        getMenteeFaqs: builder.query<Faqs, { search?: string }>({
            query: args => ({
                url: '/mentee/faqs?offset=0&limit=100&orderBy=createdAt&orderDirection=DESC',
                method: 'GET',
                params: {
                    search: args.search,
                },
            }),
            async onQueryStarted(_arg, { dispatch, queryFulfilled }) {
                try {
                    await queryFulfilled;
                } catch (error) {
                    dispatch(showToast({ variant: 'error', description: error?.error }));
                }
            },
        }),
        contactUs: builder.mutation<GeneralSuccessResponse, ContactSupportPayload>({
            query: body => ({
                url: `/contact-us`,
                method: 'POST',
                body,
            }),
        }),
    }),
    overrideExisting: true,
});

export const {
    useLazyGetMenteeFaqsQuery,
    useLazyGetMentorFaqsQuery,
    useContactUsMutation,
    useGetAllFaqsQuery,
} = faqs;
